import { Component as BaseComponent, h } from 'preact';
import { connect } from 'preact-redux';
import moment from 'moment';
import DatePicker from '../../date-picker';
import PromoMessage from '../../promo-message';

class Component extends BaseComponent {
    render({ route }) {
        if (route != 'everyone') {
            return this.renderForYou();
        }

        return this.renderForEveryone();
    }

    renderForYou = () => {
        if (this.props.logged_in && this.props.tcod && this.props.tcod.you) {
            return this.renderTCOD(this.props.tcod.you);
        }

        return (
            <daily-tarot-card-non-mobile>
                <div class='daily-tarot-card'>
                    <img
                      src='https://gfx.tarot.com/images/daily-pages/daily-icons/tarot.svg'
                      class='tarot-card-unknown'
                      alt='Unknown Tarot Card'
                    />
                </div>
                <DatePicker class='icon-24x23-calendar js-datepicker' url='/daily-tarot-card/:date' />
                {this.renderDailyLinks()}
                <h1>Tarot Card of<br />the Day</h1>
                {this.renderSubLinks()}
                <br />
                <br />
                <h2>Your FREE Tarot Card Awaits!</h2>
                <br />
                <p>
                    Looking for your Tarot Card of the Day? Create your profile to receive a Tarot card that's
                    personalized to YOU every day!
                </p>
                <p>
                    <a href='#login' class='button'>GET MY DAILY TAROT CARD</a>
                </p>
            </daily-tarot-card-non-mobile>
        );
    }

    renderForEveryone = () => {
        if (this.props.tcod && this.props.tcod.everyone) {
            return this.renderTCOD(this.props.tcod.everyone);
        }

        return (
            <daily-tarot-card-non-mobile />
        );
    }

    renderDailyLinks = () => {
        const yesterday = moment().subtract(1, 'days').format('YYYY-MM-DD');
        const today = moment().format('YYYY-MM-DD');
        const tomorrow = moment().add(1, 'days').format('YYYY-MM-DD');

        return (
            <div class='daily-links'>
                <a
                  href={`/daily-tarot-card/${yesterday}#${this.props.route}`}
                  class={this.props.date == yesterday ? 'selected' : ''}
                >
                    Yesterday
                </a>
                <a
                  href={`/daily-tarot-card/${today}#${this.props.route}`}
                  class={this.props.date == today ? 'selected' : ''}
                >
                    Today
                </a>
                <a
                  href={`/daily-tarot-card/${tomorrow}#${this.props.route}`}
                  class={this.props.date == tomorrow ? 'selected' : ''}
                >
                    Tomorrow
                </a>
            </div>
        );
    }

    renderSubLinks = () => {
        return (
            <div class='daily-links'>
                <a href={this.props.route == 'everyone' ? '#you' : '#everyone'}>
                    {this.props.route == 'everyone' ? 'Your' : "Everyone's"} Tarot Card
                </a>
                <a
                  href='/readings-reports/tarot-readings/daily-reflection'
                  onClick={() => this.props.trackPromo(['TCOD', 'DRT'])}
                >
                    Get Your Daily Tarot Reading
                </a>
            </div>
        );
    }

    renderTCOD = (tcod) => {
        if (tcod) {
            const img_url = `https://gfx.tarot.com/images/site/decks/${tcod.deck_code}/full_size/${tcod.card_id}.jpg`;

            return (
                <daily-tarot-card-non-mobile>
                    <div class='daily-tarot-card'>
                        <a href={`/tarot/cards/${tcod.card.canonical_rank}/${tcod.deck_code}`} target='_blank'>
                            <img
                              src={img_url}
                              alt={tcod.card.name}
                            />
                        </a>
                        <small>
                            <a href={`/tarot/decks/${tcod.deck_code}`}>{tcod.deck.name}</a> deck
                            <br />
                            © U.S. Games Systems, Inc.
                        </small>
                    </div>
                    <DatePicker class='icon-24x23-calendar js-datepicker' url='/daily-tarot-card/:date' />
                    {this.renderDailyLinks()}
                    <h1>Tarot Card of<br />the Day</h1>
                    {this.renderSubLinks()}
                    <br />
                    {tcod.interp_body.map((p, key) => {
                        if (key == 0) {
                            return (
                                <p>
                                    <b>{moment(this.props.date).format('M.D.YY')} {tcod.card.name}: </b>
                                    {p}
                                </p>
                            );
                        }
                        return (<p>{p}</p>);

                    })}
                    <p><PromoMessage placement='text-tarot' /></p>
                </daily-tarot-card-non-mobile>
            );
        }

        return null;
    }
}

const mapStateToProps = (state) => ({
    tcod: state.tcod,
    logged_in: state.user && state.user.logged_in,
    route: state.route,
});

const mapDispatchToProps = (dispatch) => ({
    trackPromo: (payload) => dispatch({ type: 'promo-tracker:recordInternal', payload: payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);



// WEBPACK FOOTER //
// ./app/components/daily/tarot-card/non-mobile.js